import { Shimmer } from '@components';

import { Container } from './StatusList.styles';

export const StatusListLoading = () => {
  return (
    <Container>
      <Shimmer
        style={{
          height: 20,
          width: '100%',
          borderRadius: 4,
          marginBottom: 16,
        }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
      <Shimmer
        style={{
          height: 20,
          width: '100%',
          borderRadius: 4,
          marginBottom: 16,
        }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
      <Shimmer
        style={{
          height: 20,
          width: '100%',
          borderRadius: 4,
        }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
    </Container>
  );
};
